import { TextButton } from '@wix/design-system';
import React from 'react';
import { CoreDomainSearchDataHooks, CoreDomainSearchModule } from '../../module/module';
export const ClearFilters = _ref => {
  let {
    onClear,
    underline
  } = _ref;
  const {
    t
  } = CoreDomainSearchModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(CoreDomainSearchModule.SDK.Layouts.ClearFiltersContainer, null, /*#__PURE__*/React.createElement(TextButton, {
    onClick: onClear,
    size: "small",
    variant: "tertiary",
    dataHook: CoreDomainSearchDataHooks.clearFilters,
    skin: "dark",
    underline: underline ? 'always' : 'none'
  }, t('core_domain_search.domain_gate.clear_filters')));
};
//# sourceMappingURL=ClearFilters.js.map